import * as http from 'http'
import * as url from 'url'
import * as querystring from 'querystring'
import {merge} from 'lodash'
import {PromiseRejecter, PromiseResolver} from "./types";

export class AjaxRequest {
	private url:UrlPortFixer

	constructor(ajaxPageUrl:string) {
		this.url = new UrlPortFixer(url.parse(ajaxPageUrl, true))
	}

	public postForm<T>(form:{}, GET_data:{} = {}):Promise<T> {
		return this.runPost<T>('application/x-www-form-urlencoded', querystring.stringify(form), GET_data)
	}

	public runPost<T>(contentType:string, POST_body?:string, GET_data:{} = {}):Promise<T> {
		// TODO Convert this to use the Node.js/Webpack "http" module instead of XMLHttpRequest
		// The reason it uses XMLHttpRequest is because there was some request format incompatibility with PHP's
		// request parser that Tristan didn't have time to figure out.
		const req  = new XMLHttpRequest()
		const url3 = this.url.urlWithPortAsString(GET_data)

		req.open('POST', url.format(url3))
		req.setRequestHeader('Content-Type', contentType)
		req.setRequestHeader('Content-Length', POST_body == null ? '0' : Buffer.byteLength(POST_body).toString())
		return new Promise<T>((resolve, reject) => {
			const finalizer        = new AjaxRequestFinalizer<T>(resolve, reject)
			req.onreadystatechange = () => finalizer.handleReadyStateChange(req)
			if (POST_body == null) {
				req.send()
			} else {
				req.send(POST_body)
			}
		})
	}

	public runGet<T>(params:Object):Promise<T> {
		const req = merge({method: "GET"}, this.url.urlWithPortAsNumber(params))

		return new Promise<T>((resolve, reject) => {
				const finalizer = new AjaxRequestFinalizer<T>(resolve, reject)
				const client    = http.request(req)
				client.on('abort', () => finalizer.handleError({statusNumber:-1,reason:'aborted by user'}))
				client.on('response', (message:http.IncomingMessage) => finalizer.handleIncomingMessage(message))
				client.end()
			}
		)
	}
}

class AjaxRequestFinalizer<T> {
	constructor(
		private resolve:PromiseResolver<T>,
		private reject:PromiseRejecter<T>
	) {
	}

	handleError(reason:{statusNumber?:number,reason?:string }) {
		this.reject({source: "AjaxRequestFinalizer", ...reason})
	}

	handleReadyStateChange(req:XMLHttpRequest) {
		if (req.readyState !== XMLHttpRequest.DONE) {
			return
		} else if (req.status !== 200) {
			this.handleError({statusNumber:req.status,reason:req.statusText})
		} else {
			this.handleSuccess(req.responseText)
		}
	}

	handleIncomingMessage(message:http.IncomingMessage) {
		var data = ''
		message.on('data', (chunk:string) => data += chunk)
		message.on('end', () => this.finalize(data, message.statusCode, message.statusMessage))
	}

	private finalize(data:string, statusNumber?:number, statusMessage?:string) {
		if (statusNumber === 200) {
			this.handleSuccess(data)
		} else {
			this.handleError({statusNumber:statusNumber, reason:statusMessage})
		}
	}

	private handleSuccess(data:string) {
		try {
			this.resolve(JSON.parse(data))
		} catch (e) {
			this.reject(e)
		}
	}
}

class UrlPortFixer {
	constructor(private url_:url.Url) {
	}

	urlNoPort(GET_params:Object) {
		const search = querystring.stringify(merge({}, this.url_.query, GET_params))
		return {
			protocol: this.url_.protocol,
			hostname: this.url_.hostname,
			pathname: this.url_.pathname,
			search:   search,
			path:     this.url_.pathname + '?' + search,
		}
	}

	urlWithPortAsNumber(GET_params:Object) {
		return merge({port: this.url_.port ? parseInt(this.url_.port) : null}, this.urlNoPort(GET_params))
	}

	urlWithPortAsString(GET_params:Object) {
		return merge({port: this.url_.port ? this.url_.port : null}, this.urlNoPort(GET_params))
	}
}



// WEBPACK FOOTER //
// ./src/lib/ajax.ts